export default ({
  EDIT: 'Edit',
  VIEW: 'View',
  ADD: 'Add'
});
